import React from "react";
import FakeProgress from "../../components/FakeProgress";

interface Props {
  fileNames: string[]
  hasFinishedUploading: boolean
  onFinish: () => void
}

const UploadingRow = (props: Props) => <div className="flex-column">
  <div>
    {props.fileNames.join(", ")}
  </div>
  <div>
    <FakeProgress
      isDone={props.hasFinishedUploading}
      onFinish={props.onFinish}
      speed="slower"
    />
  </div>
</div>;

export default UploadingRow;